module.exports = __webpack_public_path__ + "img/dissatisfaction.2667101a.svg";